import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { RewardService } from 'src/app/core/api/reward/reward.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { SortOption } from 'src/app/shared/models/constants/sort-option';
import { RewardResponseDTO } from 'src/app/shared/models/dtos/responses/reward-response-dto/reward-response-dto';

@Component({
  selector: 'app-opportunity-grid',
  templateUrl: './opportunity-grid.component.html',
  styleUrls: ['./opportunity-grid.component.scss'],
})
/**
 * Grid that display cards of rewards
 */
export class OpportunityGridComponent implements OnInit, OnDestroy {
  rewards: RewardResponseDTO[] = [];
  labels = {
    rewards: 'rewards',
    notFound: 'reward-not-list',
    notFoundDescription: 'reward-not-list-description',
    opportunities: 'opportunities',
  };

  loading = false;
  private page = 0;
  private pageSize = 25;
  private defaultSort = SortOption.MOST_CLAIMED;
  private subsink = new Subscription();

  disableAll = false;

  /**
   * @constructor
   */
  constructor(
    public translationService: TranslationService,
    public rewardService: RewardService
  ) {}

  /**
   * ng on init
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
    this.pullRewards();
  }

  /**
   * cleans up resources
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  /**
   * Loads more items
   */
  pullRewards() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      sort: this.defaultSort,
      opportunities: true,
    };
    const rewards$ = this.rewardService
      .getRewards(params)
      .subscribe((rewards) => {
        if (rewards.length > 0) {
          this.page++;
        }
        this.rewards.push(...rewards);
      })
      .add(() => {
        this.loading = false;
      });
    this.subsink.add(rewards$);
  }

  /**
   * @param {boolean} loading
   */
  redeeming(loading: boolean) {
    this.disableAll = loading;
  }
}
